import { Button } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import useBigVisible from 'hooks/useBigFold';
import TradeReturnProduct from './TradeReturnProduct';
import { useTranslate } from '@tolgee/react';

interface TradeProductsRefundProps {
  reviewId?: string;
  conversation: Conversation.Conversation;
  itemsData: Conversation.Trade.ReturnProductsData;
  trade: Conversation.Trade.TradeWithLogistics;
  lazyScrollContainer?: Element | null;
}

const LazadaProductsRefund = (props: TradeProductsRefundProps) => {
  const { conversation, itemsData, reviewId, trade } = props;
  const { returnSnObj } = itemsData;
  const { t } = useTranslate();
  const refundItemsVisible = useBigVisible();
  const {
    visible: isRefundItemsUnfold,
    loading: refundItemsLoading,
    show: showRefundItems,
    hide: hideRefundItems,
  } = refundItemsVisible;

  const list = Object.keys(returnSnObj).reduce<
    { sn: string; data: Conversation.Trade.ReturnProduct }[]
  >((res, sn) => {
    return returnSnObj[sn].reduce((res, data) => {
      res.push({ sn, data });

      return res;
    }, res);
  }, []);

  if (list.length > 0) {
    return (
      <div>
        {(isRefundItemsUnfold ? list : list.slice(0, 2)).map(({ sn, data }) => {
          return (
            <TradeReturnProduct
              key={sn}
              reviewId={reviewId}
              sn={sn}
              conversation={conversation}
              data={[data]}
              trade={trade}
            />
          );
        })}
        {list.length > 2 && (
          <Button
            block
            loading={refundItemsLoading}
            type="link"
            onClick={() => (isRefundItemsUnfold ? hideRefundItems() : showRefundItems())}
          >
            {isRefundItemsUnfold
              ? t('scene.chatWorkspace.orderTab.action.collapse')
              : t('scene.chatWorkspace.orderTab.action.expand')}
            {isRefundItemsUnfold ? <CaretUpOutlined /> : <CaretDownOutlined />}
          </Button>
        )}
      </div>
    );
  }

  return null;
};

export const TradeProductsRefund = (props: TradeProductsRefundProps) => {
  const { conversation, itemsData, trade, reviewId, lazyScrollContainer } = props;
  const { channel } = conversation;
  const { returnSnObj } = itemsData;

  if (channel === 'LAZADA') {
    return <LazadaProductsRefund {...props} />;
  }

  return (
    <>
      {Object.keys(returnSnObj).map((sn) => {
        return (
          <TradeReturnProduct
            key={sn}
            sn={sn}
            conversation={conversation}
            data={returnSnObj[sn]}
            trade={trade}
            reviewId={reviewId}
            lazyScrollContainer={lazyScrollContainer}
          />
        );
      })}
    </>
  );
};
